import { useState } from "react"
import './employment.css'
export default function Employment() {
  const [loginStatus, setLoginStatus] = useState(null);
  const [loadingcheack , setLoadingcheck] = useState(false)
  const [codevalue , setCodevalue] = useState('')
  const [experience, setExperience] = useState("");
  const [error, setError] = useState("");
  const [result , setResult] = useState('')
  const [formData, setFormData] = useState({
    code: Math.floor( Math.random() * (100000 - 10000) ) + 50,
    firstName: "",
    lastName: "",
    birthDate: "",
    skills: "",
    address: "",
    phone: "",
    email: "",
    educationLevel: "",
    major: "",
    experience: "",
    money: "",
  });
  async function checking(e) {
    e.preventDefault();
    if(codevalue) {
      setLoadingcheck(true)
      try {
        const response = await fetch("http://185.164.73.170:5000/getExperience", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ codevalue }),
        });
  
        if (response.ok) {
          const data = await response.json();
          setExperience(data.status === 'accepted' ? 'قبول شده' : data.status === 'rejected' ? 'رد شده' : data.status === 'pending' ? 'کد وارد شده اشتباه است' : 'در صف انتظار');
          setError("");
          setLoadingcheck(false)
        }else{
          setExperience('کد استباه است')
          setLoadingcheck(false)
        }
      } catch (err) {
        setError(err.message);
        setExperience("");
      }
    }
  }
  function getcode(e) {
    setCodevalue(e.target.value)
  }
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        const postResponse = await fetch("http://185.164.73.170:5000/apply", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        if (postResponse.ok) {
          setResult(`رزومه درخواست استخدام ارسال شد کد پیگیری شما ${formData.code}`);
          setFormData({
            code: Math.floor( Math.random() * (100000 - 10000) ) + 50,
            firstName: "",
            lastName: "",
            birthDate: "",
            skills: "",
            address: "",
            phone: "",
            email: "",
            educationLevel: "",
            major: "",
            experience: "",
            money: "",
          });
        } else {
          setResult("مشکل در اینترنت");
        }
    } catch (error) {
      console.error('Error:', error);
      setLoginStatus('خطایی رخ داده است.');
    }
  };
  function title() {
    document.title = 'تهران مو | استخدام'
  }
  title()

  return (
    <div className="employmentpage">
      <div className="employmentbox">
        <form onSubmit={handleSubmit}>
          <div className="employmentinput">
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="نام"
              maxLength={20}
              required
            />
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="نام خانوادگی"
              maxLength={20}
              required
            />
            <input
              type="text"
              name="birthDate"
              value={formData.birthDate}
              onChange={handleChange}
              placeholder="تاریخ تولد"
              maxLength={25}
              required
            />
            <input
              type="text"
              name="skills"
              value={formData.skills}
              onChange={handleChange}
              placeholder="مهارت"
              maxLength={40}
              required
            />
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="آدرس"
              maxLength={80}
              required
            />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="شماره تلفن"
              maxLength={15}
              required
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="ایمیل"
              maxLength={30}
              required
            />
            <input
              type="text"
              name="educationLevel"
              value={formData.educationLevel}
              onChange={handleChange}
              placeholder="آخرین مدرک تحصیلی"
              maxLength={30}
              required
            />
            <input
              type="text"
              name="major"
              value={formData.major}
              onChange={handleChange}
              placeholder="رشته تحصیلی"
              maxLength={30}
              required
            />
            <input
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              placeholder="سابقه کار"
              maxLength={40}
              required
            />
            <input
              type="text"
              name="money"
              value={formData.money}
              onChange={handleChange}
              placeholder="حقوق درخواستی"
              maxLength={30}
              required
            />
            <p style={{userSelect: 'auto'}}>{result}</p>
            <button type="submit">ارسال</button>
          </div>
          <div className="checkresult">
            <form>
              <input onChange={getcode} type="number" placeholder="کد پیگیری وارد کنید" required></input>{experience} <div className='spinner' style={{display: loadingcheack === true ? 'block' : 'none'}}></div>
              <button onClick={checking}>چک کردن</button>
            </form>
          </div>
        </form>
        {loginStatus}
      </div>
    </div>
  );
}